import type { FetchKeys } from '@/api/v1/generated-api.gen'
import type { IdAndName } from '@/types/id-and-name'

const EDUCATION_LEVELS: IdAndName[] = [
  {
    id: 'BqVEZc6NmsGRDL7gyJtjof',
    name: 'Preschool'
  },
  {
    id: 'KjxBQhcgKPvmR6fLDPEn3M',
    name: 'Primary'
  },
  {
    id: 'Zx9xtwRBhKjcH94gbgPUuN',
    name: 'Middle'
  },
  {
    id: 'dnEpNyqcu9ReNkTtQrh87v',
    name: 'High'
  },
  {
    id: 'Eveba8NVogCnUPY53yoBWj',
    name: 'Higher'
  }
]

type SchoolYears = {
  name: string
  start_year: string
  end_year: string
  education_level: IdAndName
}

const currentYear = new Date().getFullYear()
const yearsCount = 4

const createSchoolYearsMock = (
  index: number,
  educationLevel: IdAndName
): SchoolYears => ({
  name: `${currentYear + index}-${currentYear + index + yearsCount}`,
  start_year: `start-${index}-${educationLevel.id}`,
  end_year: `end-${index}-${educationLevel.id}`,
  education_level: educationLevel
})

const allSchoolYearsMock = EDUCATION_LEVELS.flatMap(educationLevel =>
  Array.from({ length: yearsCount }, (_, index) =>
    createSchoolYearsMock(index, educationLevel)
  )
)

type Params = {
  education_level_id?: string[]
  page?: number
  page_size?: number | 'max'
  fetchKeys?: FetchKeys<SchoolYears>
}

export const createSchoolYearsListMock = (params: Params) => {
  const educationLevelId = params?.education_level_id?.[0]
  const results = educationLevelId
    ? allSchoolYearsMock.filter(
        schoolYear => schoolYear.education_level.id === educationLevelId
      )
    : allSchoolYearsMock

  const count = results.length

  return {
    count,
    current: 1,
    page_size: count,
    next: null,
    previous: null,
    results
  }
}
